import store from '../store/Store';
import type BookingMeetingType from 'owa-service/lib/contract/BookingService';

/**
 * Util to get meetingTypes from the store.
 */
export default function getMeetingTypes(): Map<string, BookingMeetingType> {
    const meetingTypes = store.meetingTypes;
    return meetingTypes || new Map<string, BookingMeetingType>();
}
